import React from "react";
import { Route, Routes } from "react-router-dom";
import Flights from "./Flights";
import OnewaySRP from "./Flights/Oneway";
import RoundSRP from "./Flights/Round";
import BookFlight from "./Flights/Book";
import ConfirmFlight from "./Flights/Confirm";
import FlightHome from "./Flights";

function Travel() {
	return (
		<Routes>
			<Route path="/flights/book" element={<BookFlight />} />
			<Route path="/flights/confirm" element={<ConfirmFlight />} />
			<Route path="/flights/round" element={<RoundSRP />} />
			<Route path="/flights/oneway" element={<OnewaySRP />} />
			<Route path="/flights" element={<Flights />} />
			<Route path="/" element={<FlightHome />} />
		</Routes>
	);
}

export default Travel;
